import Anchor from './anchor';
Anchor.install = function (app) {
    app.component(Anchor.name, Anchor);
    app.component(Anchor.Link.name, Anchor.Link);
    return app;
};
export default Anchor;
